import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { COMPOSER_DEEP_LINKS } from 'routes/composerDeepLinks'
import { openComposerContentDialog } from 'services/ui'
import { StoreThunkDispatch } from 'store/state'

export function ComposerContentDeepLink() {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const navigate = useNavigate()
  const location = useLocation()
  const pathname = location.pathname.replace(/\/+$/, '') || '/'

  useEffect(() => {
    const config = COMPOSER_DEEP_LINKS[pathname]
    if (!config) {
      return
    }
    dispatch(openComposerContentDialog(config))
    navigate('/composer', { replace: true, state: location.state })
  }, [pathname, dispatch, navigate, location.state])

  return null
}

export default ComposerContentDeepLink
